import { RootState } from "../../../../../redux/store";

export const isItemsLoading = (state:RootState) => state.rejectionReasons.itemsLoading;
export const isItemActionLoading = (state:RootState) => state.rejectionReasons.actionsLoading;
export const getItems = (state:RootState) => state.rejectionReasons.items;
export const getItemsSelect = (state:RootState) => state.rejectionReasons.dropDownItems;
export const getItemsCount = (state:RootState) => state.rejectionReasons.itemsCount;
export const getItemForEdit = (state:RootState) => state.rejectionReasons.itemForEdit;
export const getError = (state:RootState) => state.rejectionReasons.error;
export const getErrorAction = (state:RootState) => state.rejectionReasons.errorAction;
export const validationErrors = (state:RootState) => state.rejectionReasons.validationErrors;
